import { useCallback, useContext } from 'react';

import {
	END_OF_TRIAL_MODAL_EXPERIENCE,
	ExperienceTrackerContext,
} from '@confluence/experience-tracker';
import { useSessionData } from '@confluence/session-data';

import { useOperationalInfo } from '../store/operationalStore';
import { useUserInfo } from '../store/userInfoStore';
import { useExperimentInfo } from '../store/experimentInfoStore';
import { statsigCohorts } from '../experimentConstants';

export const useHandleExperienceTrackerError = () => {
	const experienceTracker = useContext(ExperienceTrackerContext);
	const { daysLeftInTrial, billingSourceSystem, modalKey, hasModalBeenSeen } = useUserInfo();
	const { edition } = useSessionData();
	const { cohort, epMessageReady } = useExperimentInfo();
	const { error } = useOperationalInfo();
	const handleExperienceTrackerError = useCallback(() => {
		if (error) {
			return experienceTracker.stopOnError({
				name: END_OF_TRIAL_MODAL_EXPERIENCE,
				error,
				attributes: {
					edition,
					daysLeftInTrial,
					cohort,
					billingSourceSystem,
					modalKey,
					hasModalBeenSeen,
					epMessageReady,
				},
			});
		}

		if (cohort === statsigCohorts.NON_ENROLLED) {
			return experienceTracker.abort({
				name: END_OF_TRIAL_MODAL_EXPERIENCE,
				reason: 'Not enrolled in Statsig',
			});
		}

		// handle ineligible user
		return experienceTracker.abort({
			name: END_OF_TRIAL_MODAL_EXPERIENCE,
			reason: 'Ineligible for experience',
			attributes: {
				edition,
				daysLeftInTrial,
				cohort,
				billingSourceSystem,
				modalKey,
				hasModalBeenSeen,
				epMessageReady,
			},
		});
	}, [
		billingSourceSystem,
		cohort,
		daysLeftInTrial,
		edition,
		epMessageReady,
		error,
		experienceTracker,
		hasModalBeenSeen,
		modalKey,
	]);

	return { handleExperienceTrackerError };
};
